import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWhiteboard1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="whiteboard-1, artboard"><path d="M17 21.25L16.1554 18.7162M7 21.25L7.84461 18.7162M12 4.75H2.75V18.25H21.25V4.75H12ZM12 4.75V2.75M12 20.25V18.7162" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWhiteboard1;
